interface HttpError extends Error {
  statusCode?: number;
}

export class NotAuthorizedError extends Error {}
export class PreconditionFailedError extends Error {}

export class ResourceNotFoundError extends Error {
  statusCode = 404;
  override name = 'ResourceNotFoundError';
  constructor(message?: string) {
    super(message);
  }
}

export class BadRequestError extends Error {
  statusCode = 400;
  override name = 'BadRequestError';
  constructor(message?: string) {
    super(message);
  }
}

export class InvalidCredentialsError extends Error {
  statusCode = 401;
  override name = 'InvalidCredentialsError';
  constructor(message?: string) {
    super(message);
  }
}

export class InvalidArgumentError extends Error {
  statusCode = 409;
  override name = 'InvalidArgumentError';
  constructor(message?: string) {
    super(message);
  }
}

export class MissingParameterError extends Error {
  statusCode = 409;
  override name = 'MissingParameterError';
  constructor(message?: string) {
    super(message);
  }
}

const errors = {
  makeErrFromCode: (errorCode: number, errorDescription: string): HttpError => {
    const error: HttpError = new Error(`${errorDescription}`);
    error.statusCode = errorCode;
    return error;
  },
  NotAuthorizedError,
  PreconditionFailedError,
  ResourceNotFoundError,
  BadRequestError,
  InvalidCredentialsError,
  InvalidArgumentError,
  MissingParameterError,
};

export default errors;
